document.addEventListener('DOMContentLoaded', function() {
    var elapsedTime = 0;
    /*if(getCookie('showModal')==null){
        $('.modal-nl').modal();
        setCookie('exit-intent-show','false',7) 
    }*/
  
    var exitIntentShown = false;

    document.addEventListener('mouseleave', function(event) {
        if (event.clientY < 0 && !exitIntentShown) {
            showExitIntent();
            
        }
    });

    function showExitIntent() {

        var exitshowtime = parseInt($('.modal-exit-intent').data('exitintenttime'));
        if (elapsedTime >= exitshowtime && getCookie('exit-intent-show') == null) {
            exitIntentShown = true;
            $('.modal-exit-intent').modal();
            setCookie('exit-intent-show', true, 1);
        }
        
    }

    var currentTime = new Date().getTime();
    var startTime = getCookie('exit-intent-time');

    if (startTime == null) {
        setCookie('exit-intent-time', currentTime, 1);
        startTime = currentTime;
    }

    var checkTime = function() {
        elapsedTime = (new Date().getTime() - startTime) / 1000; // in Sekunden
    };

    setInterval(checkTime, 1000); // Überprüfe alle 1 Sekunde

});
$(document).on('click', '.coupon-btn-copy', function(event){      

    var copyText = document.getElementById("copy-txt-clip");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    $('.coupon-btn-copy').addClass('has-copied')
    return false;
});